<div class="planner">
  <div class="planner-header">
    <div>
      <h2>Availability — next 7 days</h2>
      <p class="planner-hint">
        Drag on the timeline to create a segment. Drag handles to adjust. Max
        {{ maxSegmentsPerDay }} segments / {{ maxTotalHours }} h per day.
      </p>
    </div>
    <div class="planner-actions">
      <span class="submitted-badge"
        >{{ submittedCount }}/{{ days.length }} submitted</span
      >
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="saving || loading"
        (click)="onSubmitAll()"
        >Submit all 7 days</button
      >
    </div>
  </div>

  <div *ngIf="loading" class="planner-loading">Loading availability…</div>

  <div *ngIf="!loading" class="planner-days">
    <app-day-card
      *ngFor="let day of days; trackBy: trackByDate"
      [day]="day"
      [events]="events"
      (dayChange)="onDayChange(day.date, $event)"
    ></app-day-card>
  </div>
</div>
